/**
 * Google OAuth só em produção e localhost.
 * No Preview Vercel (develop), o redirect_uri usa NEXT_PUBLIC_APP_URL de
 * produção e manda o usuário pra calculamei.com.br — por isso fica desligado.
 * Login/cadastro por e-mail continuam normais no preview.
 */
export function isGoogleOAuthEnabled(): boolean {
  const env = process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV
  if (env === 'preview') return false
  return true
}
